import React from "react"
import { Box, Checkbox, Stack, Typography } from "@mui/material"
import { capitalizeFirstLetter, roundNumber } from "../../../utils"
import PrintPSE from "../print/PrintPSE"

const getPSEsGrossWeightSum = (productionStepExecutions = []) => {
  const totalWeight =  productionStepExecutions.reduce((acc, pse) => acc + pse.realWeight, 0)

  return roundNumber(totalWeight, 2)
}

const formatQuantity = (weight, unitGrossWeight, servingUnit = "weight") => {
	if (servingUnit === "piece" && unitGrossWeight) {
		const pieces = Math.ceil(weight / unitGrossWeight)
		const label = pieces > 1 ? "pièces" : "pièce"
		return `${pieces} ${label} (${weight} kg)`
	}
	// default to just weight in kg
	return `${weight} kg`
}

// The label shows the ingredient name in place of the step name
const withIngredientName = (pse, ingredient) => ({ ...pse, productionStepSnapshot: { ...pse.productionStepSnapshot, name: capitalizeFirstLetter(ingredient.name) } })

const sx = {
  card: {
    padding: "16px",
    borderRadius: "8px",
    backgroundColor: "#E3F2FD"
  },
  cardTitle: {
    fontWeight: 500,
    color: "#000",
    fontSize: "16px",
    lineHeight: 1.5
  },
  // Takes the rest of the title row to right align the button with those of the rows (card body padding).
  // Padding, not margin: the Stack spacing resets the margins of its children
  printAll: {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "16px"
  },
  cardBody: {
    backgroundColor: "#fff",
    padding: "8px 16px",
    borderRadius: "8px",
  },
  pseLabel: {
    fontWeight: 400,
    color: "#555",
    fontSize: "16px",
    lineHeight: 1.5
  }
}

const UnpackingPSEsByIngredientsForm = ({ onSelect, status = "TODO", ingredients = [] }) => {

  return (
    <Stack
      spacing={3}
    >
      {ingredients.map((ingredient, index) => (
        <Stack key={index + ingredient.objectId} spacing={2} sx={sx.card}>
          {/* title */}
          <Stack direction="row" spacing={1} alignItems="center">
            <Checkbox
              checked={status === "DONE"}
              onChange={() => onSelect?.(ingredient, status)}
              sx={{
                color: "#1976D2",
                "& .MuiSvgIcon-root": {
                  fontSize: 32,
                },
                "&.Mui-checked": {
                  color: "#1976D2",
                },
              }}
            />
            <Typography variant="h4" sx={sx.cardTitle}>
              {ingredient.name} - {formatQuantity(
                getPSEsGrossWeightSum(ingredient.productionStepExecutions),
                ingredient.unitGrossWeight,
                ingredient.servingUnit
              )}
            </Typography>
            <Box sx={sx.printAll}>
              <PrintPSE pses={ingredient.productionStepExecutions.map(pse => withIngredientName(pse, ingredient))} />
            </Box>
          </Stack>

          {/* body */}
          <Stack spacing={2} sx={sx.cardBody}>
            {ingredient.productionStepExecutions.map((pse, subIndex) => (
              <Stack key={subIndex + index + pse.objectId} direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                <Typography variant="body2" sx={sx.pseLabel}>
                  {formatQuantity(pse.realWeight, ingredient.unitGrossWeight, ingredient.servingUnit)}
                  {pse.productionStepSnapshot.description ? ` (${pse.productionStepSnapshot.description})` : ""}
                </Typography>
                <Stack direction="row" spacing={4} alignItems="center">
                  <Typography variant="body2" sx={sx.pseLabel}>
                    {pse.uniqueCode}
                  </Typography>
                  <PrintPSE pse={withIngredientName(pse, ingredient)} />
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Stack>
      ))}
    </Stack>
  )
}

export default UnpackingPSEsByIngredientsForm